import { createView } from './requests/create'
import { deleteView } from './requests/delete'
import { deleteBlocksRelationship } from './requests/deleteBlocksRelationship'
import { readView, readViews } from './requests/read'
import { updateView } from './requests/update'

export { useCreateView } from './useCreateView'
export { useDeletePlan } from './useDeleteView'
export { useUpdatePlan } from './useUpdateView'

export const views = {
  create: createView,
  delete: deleteView,
  deleteBlocksRelationship,
  readCollection: readViews,
  readSingle: readView,
  update: updateView,
}
